import * as React from 'react'
import Fade from 'react-reveal/Fade'
import PropTypes from 'prop-types'
import * as style from './form.module.scss'
import Section from '../../common/SectionComponent/Section'
import Form from './Form'
import useFormTitleHook from '../../../hooks/query/useFormTitleHook'

const FormSection = ({ showTitle }) => {
  const formQueryData = useFormTitleHook()
  const { formDescription, formTitle } = formQueryData

  return (
    <Section hideText={!showTitle} title={formTitle} isLight>
      <Fade bottom>
        <p className={style.description}>{formDescription}</p>
      </Fade>
      <Form />
    </Section>
  )
}
FormSection.propTypes = {
  showTitle: PropTypes.bool,
}
FormSection.defaultProps = {
  showTitle: true,
}
export default FormSection
